// CircularLoader.js
import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const CircularLoader = ({ percentage }) => {
  return (
    <div style={{ width: 40, height: 40 }}>
      <CircularProgressbar
        value={percentage}
        styles={buildStyles({
          textColor: "#000",
          pathColor: "#630B99",
          trailColor: "#ffffff",
        })}
      />
    </div>
  );
};

export default CircularLoader;
